var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',[(_vm.item.statusId === 2)?_c('div',{staticClass:"text-red-500 float-right"},[_vm._v(" "+_vm._s(_vm.$t("Common.General.Blocked"))+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.item.name)+" ("+_vm._s(_vm.item.id)+") ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }